module.exports = __webpack_public_path__ + "img/noData.f299c1bc.png";